export class ImportarArquivoRequest {
    arquivoBase64: string = '';
}
